import { Win, Big, Row, Empty, money } from "./Win";
import { CalendarClock, CreditCard, Scale, CalendarOff } from "lucide-react";

const fmtDate = (d) => { const [y, m, dd] = d.split("-"); return `${dd}/${m}/${y.slice(2)}`; };
const fmtTime = (t) => { if (!t) return ""; const [h, m] = t.split(":").map(Number); return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${h >= 12 ? "PM" : "AM"}`; };

export function UpcomingWin({ d, onOpen }) {
  const list = d.upcoming_appointments;
  return (
    <Win title="Upcoming Appointments" icon={CalendarClock} to="/appointments" testid="win-upcoming">
      {list.length ? (
        <ul className="space-y-2 mt-1">
          {list.slice(0, 6).map((a) => (
            <li key={a.id} data-testid={`upcoming-${a.id}`} className="text-sm flex items-start gap-3">
              <div className="text-right shrink-0 w-[68px]">
                <p className="text-primary font-medium leading-tight">{fmtTime(a.time)}</p>
                <p className="text-[11px] text-muted-foreground">{fmtDate(a.date)}</p>
              </div>
              <div className="min-w-0 flex-1">
                <p className="truncate font-medium">{a.customer_name}</p>
                <p className="text-[11px] text-muted-foreground truncate">{a.service_name} · {a.staff_name} · {a.branch.split("–").pop().trim()}</p>
              </div>
            </li>
          ))}
        </ul>
      ) : <Empty text="No upcoming appointments." />}
    </Win>
  );
}

export function PaymentModesWin({ d }) {
  const p = d.payment_modes;
  const real = p.modes.filter((m) => m.real_money);
  const wallet = p.modes.filter((m) => !m.real_money);
  return (
    <Win title="Payment Mode Collection" icon={CreditCard} to="/reports?open=pay_source" testid="win-payments">
      <Big testid="pay-total">{money(p.total_collected)}</Big>
      <p className="text-xs text-muted-foreground mt-1">Total collected {p.reconciled ? "· reconciled" : ""}</p>
      <div className="mt-4">
        {real.length ? real.map((m) => <Row key={m.mode} label={m.mode} value={money(m.amount)} testid={`pay-mode-${m.mode.replace(/\s/g, "-")}`} />)
          : <Empty text="No collections in this period." />}
        {wallet.map((m) => <Row key={m.mode} label={`${m.mode} redeemed (not collected)`} value={money(m.amount)} testid={`pay-mode-${m.mode.replace(/\s/g, "-")}`} muted />)}
      </div>
    </Win>
  );
}

export function BalanceWin({ d }) {
  const b = d.balance;
  const pos = b.net_balance >= 0;
  return (
    <Win title="Expense & Balance" icon={Scale} to="/reports?open=pnl" testid="win-balance">
      <Big testid="net-balance" className={pos ? "text-primary" : "text-red-400"}>{money(b.net_balance)}</Big>
      <p className="text-xs text-muted-foreground mt-1">Net balance = collected − expense</p>
      <div className="mt-4">
        <Row label="Total business (bill value)" value={money(b.total_business)} testid="bal-business" />
        <Row label="Total collected" value={money(b.total_collected)} testid="bal-collected" strong />
        {b.wallet_redeemed > 0 && <Row label="Wallet redeemed" value={money(b.wallet_redeemed)} testid="bal-wallet" muted />}
        <Row label="Outstanding" value={money(b.outstanding)} testid="bal-outstanding" muted />
        <Row label="Total expense" value={money(b.total_expense)} testid="bal-expense" />
      </div>
    </Win>
  );
}

export function WeeklyOffWin({ d }) {
  const w = d.weekly_off;
  return (
    <Win title={`Weekly Off · ${w.weekday}`} icon={CalendarOff} to="/staff" testid="win-weekly-off">
      <Big testid="weekly-off-count">{w.count}</Big>
      <p className="text-xs text-muted-foreground mt-1">staff on weekly off today</p>
      <div className="mt-4">
        {w.staff.length ? w.staff.slice(0, 6).map((s) => (
          <Row key={s.staff_id} label={<span><span className="font-medium">{s.name}</span> <span className="text-muted-foreground text-xs">· {s.designation}</span></span>}
            value={<span className="text-xs text-muted-foreground">{s.branch.split("–").pop().trim()}</span>} testid={`weekly-off-${s.staff_id}`} />
        )) : <Empty text="Everyone is working today." />}
        {w.staff.length > 6 && <p className="text-xs text-muted-foreground mt-1">+{w.staff.length - 6} more</p>}
      </div>
    </Win>
  );
}
